import { ObrasService } from "../../features/obras/data/services/obras_service_impl";
import { Obra } from "../../features/obras/domain/models/obra";

export type ObraRelatorioFvs = Pick<Obra, "idObra" | "centroCusto" | "empreendimento">;

export const getObrasRelatorioFvs = async (): Promise<ObraRelatorioFvs[]> => {
  const service = new ObrasService();
  const obras: ObraRelatorioFvs[] = [];
  let page = 1;
  let totalPages = 1;

  do {
    const response = await service.getAllObra({
      tipoPesquisa: null, valueField: null, statusDocumentos: null,
      resistenciaCompressao: null, statusEquipamentos: null, statusObras: null,
      page, rowsPerPage: 100,
    });
    obras.push(...response.items);
    totalPages = response.totalPages;
    page += 1;
  } while (page <= totalPages);

  return obras;
};
